import { createTheme, lightTheme } from '@backstage/theme';
import { color } from '@internal/plugin-components-react';
import createCustomThemeOverrides from './customThemeOverrides';

const baseTheme = createTheme({
  palette: {
    ...lightTheme.palette,
    action: {
      hover: color.ui.states.hover,
      focus: color.ui.states.pressed,
      disabled: color.ui.gray[300],
    },
    borderColor: {
      primary: color.ui.gray[200],
      secondary: color.ui.gray[200],
      tertiary: color.ui.gray[400],
    },
    primary: {
      main: color.ui.ab[700],
      light: color.ui.ab[200],
      dark: color.ui.ab[800],
      contrastText: color.ui.common.white,
      backgroundSoft: color.ui.ab[100],
    },
    secondary: {
      main: color.ui.gray[300],
      light: color.ui.gray[200],
      dark: color.ui.gray[700],
      contrastText: color.ui.common.black,
      backgroundSoft: color.ui.gray[100],
    },
    error: {
      main: color.ui.red[700],
      light: color.ui.red[400],
      dark: color.ui.red[800],
      contrastText: color.ui.common.white,
      backgroundSoft: color.ui.red[100],
    },
    warning: {
      main: color.ui.orange[500],
      light: color.ui.orange[300],
      dark: color.ui.orange[800],
      contrastText: color.ui.common.white,
      backgroundSoft: color.ui.orange[100],
      darkStrong: color.ui.orange[900],
    },
    info: {
      main: color.ui.blue[500],
      light: color.ui.blue[300],
      dark: color.ui.blue[700],
      contrastText: color.ui.common.white,
      backgroundSoft: color.ui.blue[100],
    },
    success: {
      main: color.ui.green[500],
      light: color.ui.green[300],
      dark: color.ui.green[700],
      contrastText: color.ui.common.white,
      backgroundSoft: color.ui.green[100],
    },
    important: {
      main: color.ui.purple[500],
      light: color.ui.purple[200],
      dark: color.ui.purple[800],
      contrastText: color.ui.common.white,
      backgroundSoft: color.ui.purple[50],
    },
    neutral: {
      main: color.ui.gray[400],
      light: color.ui.gray[100],
      dark: color.ui.gray[600],
      backgroundSoft: color.ui.gray[300],
      contrastText: color.ui.common.white,
      disabledBackground: color.ui.gray[300],
    },
    text: {
      primary: color.ui.gray[900],
      secondary: color.ui.gray[600],
      hint: color.ui.gray[500],
      disabled: color.ui.gray[400],
    },
    icon: {
      active: color.ui.gray[400],
      disabled: color.ui.gray[300],
      contrast: color.ui.common.black,
      strong: color.ui.gray[900],
    },
    background: {
      default: color.ui.gray[200],
      paper: color.ui.common.white,
      surfaceVariant: color.ui.gray[100],
      superSoft: color.ui.gray[100],
      disabled: color.ui.gray[300],
    },
    border: color.ui.gray[300],
    textContrast: color.ui.gray[900],
    textSubtle: color.ui.gray[600],
    textVerySubtle: color.ui.gray[400],
    navigation: {
      background: color.ui.gray[900],
      submenu: {
        background: color.ui.gray[700],
      },
      navItem: {
        hoverBackground: color.ui.gray[500],
      },
      color: color.ui.gray[400],
      selectedColor: color.ui.common.white,
      indicator: color.ui.ab[700],
    },
    status: {
      ...lightTheme.palette.status,
      error: color.ui.red[700],
      ok: color.ui.green[500],
      warning: color.ui.orange[500],
    },
    textColor: {
      textContrast: color.ui.gray[900],
      textSubtle: color.ui.gray[600],
      textVerySubtle: color.ui.gray[500],
      softDisabledText: color.ui.gray[400],
      inverseText: color.ui.common.white,
    },
  },
  fontFamily: 'Inter',
  defaultPageTheme: 'home',
});

export const abLightTheme = {
  ...baseTheme,
  overrides: {
    ...baseTheme.overrides,
    ...createCustomThemeOverrides(baseTheme),
  },
};
